/* eslint-disable no-unused-vars */
import bodymovin from 'lottie-web/build/player/lottie';

export default class LottieAnimation {
  constructor() {
    this.selector = '.c-new-lottie-animation';

    const elements = Array.from(document.querySelectorAll(this.selector));

    if (elements.length === 0) {
      return;
    }

    this.strings = {
      lottieReadyEvent: 'lottie-ready',
      lottieReadyClass: 'afu-lottie--ready',
    }

    this.bootstrap();
  }

  bootstrap() {
    // Add data id to lotties
    this.createIds();

    window.lottieAnimations = this.loadLotties(this.selector);
  }

  createIds() {
    const elements = Array.from(document.querySelectorAll(
      `${this.selector}`
    ));

    if (!elements) {
      return;
    }

    elements.forEach((element, index) => {
      element.dataset.id = `lottie-${index}`;
    });
  }

  loadLotties(selector) {
    const nodeList = document.querySelectorAll(selector);

    return this.loadBMAnimation(nodeList);
  }

  playAnimation(item) {
    const { id } = item.dataset;

    this.playOnScrollLotties[id].play();
  }

  // eslint-disable-next-line class-methods-use-this
  loadBMAnimation(loader) {
    const animation = [];

    loader.forEach(element => {
      if (element.classList.contains(this.strings.lottieReadyClass)) {
        return;
      }

      const { src, id, loop, autoplay } = element.dataset;

      const lottieSettings = {
        loop: loop === 'true',
        autoplay: autoplay === 'true',
        renderer: 'svg',
        container: element,
        path: src,
      };

      animation[id] = bodymovin.loadAnimation(lottieSettings);

      animation[id].addEventListener('data_ready', () => {
        window.dispatchEvent(new CustomEvent(this.strings.lottieReadyEvent, { detail: { animation: animation[id], id } }));

        element.classList.add(this.strings.lottieReadyClass);
      });
    })

    return animation;
  }
}



// WEBPACK FOOTER //
// ./scripts/components/lottie-animation.js